import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row, Statistic, Card } from "antd";
import {
  StopOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  PercentageOutlined,
  CarOutlined,
  LineChartOutlined,
} from "@ant-design/icons";
import CountUp from "react-countup";
import SkipAnalyticsContext from "../../../context/skip-analytics/context";
import Spin from "../../general/antd/spin";
import styles from "./styles.module.scss";

const SkipStatisticsCards = () => {
  const { t } = useTranslation();
  const { overallStats, loading } = useContext(SkipAnalyticsContext);

  if (loading.includes("overallStats")) {
    return (
      <div style={{ padding: "40px", textAlign: "center" }}>
        <Spin />
      </div>
    );
  }

  const stats = [
    {
      title: t("total_skips"),
      value: overallStats?.totalSkips || 0,
      icon: <StopOutlined />,
      color: "#ff4d4f",
    },
    {
      title: t("store_skips"),
      value: overallStats?.storeSkips || 0,
      icon: <ShopOutlined />,
      color: "#1890ff",
    },
    {
      title: t("order_skips"),
      value: overallStats?.orderSkips || 0,
      icon: <ShoppingCartOutlined />,
      color: "#faad14",
    },
    {
      title: t("avg_skips_per_trip"),
      value: overallStats?.avgSkipsPerTrip || 0,
      icon: <LineChartOutlined />,
      color: "#52c41a",
      decimals: 2,
    },
    {
      title: t("max_skips_per_trip"),
      value: overallStats?.maxSkipsPerTrip || 0,
      icon: <CarOutlined />,
      color: "#722ed1",
    },
    {
      title: t("skip_rate"),
      value: overallStats?.skipRate || 0,
      icon: <PercentageOutlined />,
      color: "#13c2c2",
      suffix: "%",
      decimals: 1,
    },
  ];

  return (
    <Row gutter={[16, 16]} className={styles.container}>
      {stats.map((stat, index) => (
        <Col xs={24} sm={12} md={8} lg={4} key={index}>
          <Card className={styles.card} bordered={false}>
            <div className={styles.iconWrapper} style={{ backgroundColor: `${stat.color}20` }}>
              <span style={{ color: stat.color, fontSize: "24px" }}>{stat.icon}</span>
            </div>
            <Statistic
              title={<span className={styles.title}>{stat.title}</span>}
              valueRender={() => (
                <span className={styles.value}>
                  <CountUp
                    start={0}
                    end={stat.value}
                    duration={1.5}
                    separator=","
                    decimals={stat.decimals || 0}
                    suffix={stat.suffix || ""}
                  />
                </span>
              )}
            />
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default SkipStatisticsCards;
